export default {
  state:{
    //登陆后返回的权限列表
    authority:{},
    //记住密码
    userInfo:{},
    num:0,
    //切换模式
    modeAll:1
  },
  mutations:{
    change_auth(state,userInfo){
      state.authority = userInfo
    },
    savePassword(state,pw){
      state.userInfo = pw;
    },
    changeNum(state){
      if(state.num>=0){
        state.num++
      }

    },
    changeNum1(state){
      if(state.num>=0){
        state.num--
      }
    }
  },
  action:{

  },
  getter:{

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login_store.js